(function ($, settings) {
  window.sdSppSkeleton = {
    selectors: {
      sppContent: '.js-spp-content',
      sppComponent: '[data-component="product-full"]',
      sppSkeletonCarouselImg: '.js-main-carousel-image',
      sppSkeletonProductImageList: '.elc-skeleton-child--imageList',
      sppSkeletonImageThumbnails: '.js-skeleton-carousel-image-thumbnails',
      sppSkeletonShadeDropdownName: '.js-shade-dropdown-name',
      sppSkeletonSideBarButtonWrapper: '.js-product-shades-view-button',
      sppSkeletonShadeDropdownDescription: '.js-shade-dropdown-description',
      sppSkeletonShadeDropdownHex: '.js-shade-dropdown-hex',
      sppSkeletonShadeDropdownLabel: '.js-shade-dropdown-label',
      sppSkeletonShadeGridWrapper: '.js-product-shades-grid-wrapper',
      sppSkeletonSizeChipsWrapper: '.js-slider-view-wrapper',
      sppSkeletonSizePickerWrapper: '.js-size-picker-container',
      sppSkeletonPriceWrapper: '.js-product-prices-clickable-wrapper',
      sppSkeletonSelectedSizeWrapper: '.js-product-selected-size-wrapper'
    },

    nodes: {},

    getDom: function (ctx) {
      const self = this;

      self.nodes.$sppContent = $(self.selectors.sppContent, ctx);
      self.nodes.$sppComponent = $(self.selectors.sppComponent, ctx);
      self.nodes.$sppSkeletonCarouselImg = $(self.selectors.sppSkeletonCarouselImg, ctx);
      self.nodes.$sppSkeletonProductImageList = $(self.selectors.sppSkeletonProductImageList, ctx);
      self.nodes.$sppSkeletonImageThumbnails = $(self.selectors.sppSkeletonImageThumbnails, ctx);
      self.nodes.$sppSkeletonShadeDropdownHex = $(self.selectors.sppSkeletonShadeDropdownHex, ctx);
      self.nodes.$sppSkeletonShadeGridWrapper = $(self.selectors.sppSkeletonShadeGridWrapper, ctx);
      self.nodes.$sppSkeletonSizeChipsWrapper = $(self.selectors.sppSkeletonSizeChipsWrapper, ctx);
      self.nodes.$sppSkeletonPriceWrapper = $(self.selectors.sppSkeletonPriceWrapper, ctx);
      self.nodes.$sppSkeletonSelectedSizeWrapper = $(
        self.selectors.sppSkeletonSelectedSizeWrapper,
        ctx
      );
      self.nodes.$sppSkeletonShadeDropdownName = $(
        self.selectors.sppSkeletonShadeDropdownName,
        ctx
      );
      self.nodes.$sppSkeletonSideBarButtonWrapper = $(
        self.selectors.sppSkeletonSideBarButtonWrapper,
        ctx
      );
      self.nodes.$sppSkeletonShadeDropdownLabel = $(
        self.selectors.sppSkeletonShadeDropdownLabel,
        ctx
      );
      self.nodes.$sppSkeletonShadeDropdownDescription = $(
        self.selectors.sppSkeletonShadeDropdownDescription,
        ctx
      );
      self.nodes.$sppSkeletonSizePickerWrapper = $(
        self.selectors.sppSkeletonSizePickerWrapper,
        ctx
      );
    },

    initSkeleton: function () {
      const self = this;
      const shadeName = self.getQueryParameter('shade');
      const sizeName = self.getQueryParameter('size');
      let isDefaultSku = false;

      if (shadeName || sizeName) {
        self.initSkeletonVariables(shadeName, sizeName);
        isDefaultSku =
          shadeName === self.skeleton.defaultSku?.shade_name ||
          sizeName === self.skeleton.defaultSku?.sizes?.[0]?.value;

        if (!isDefaultSku) {
          self.renderSkeleton();
        } else {
          self.applySkeletonLoadedState();
        }
      } else {
        self.applySkeletonLoadedState();
      }
    },

    applySkeletonLoadedState: function () {
      const self = this;

      self.nodes.$sppContent?.parent().addClass('skeleton-loaded');
    },

    initSkeletonVariables: function (shade, size) {
      const self = this;
      const productDataAttr = self.nodes.$sppComponent.attr('product-data');
      const sdProdcatConfig = self.nodes.$sppComponent.attr('data-config');

      self.skeleton = {};
      self.skeleton.shadeName = shade;
      self.skeleton.sizeNameQueryParameter = size;
      self.skeleton.sdProdcatConfig = sdProdcatConfig ? JSON.parse(sdProdcatConfig) : [];
      self.skeleton.productFullProdcatConfig =
        self.skeleton.sdProdcatConfig.componentElementsOrderConfig?.productFull;
      self.skeleton.productData = productDataAttr ? JSON.parse(productDataAttr) : [];
      self.skeleton.defaultSku = self.getDefaultSku();
      self.skeleton.skuProduct = self.getSkuData();
      self.skeleton.skuId = self.skeleton.skuProduct?.sku_id;
      self.skeleton.existShadeGroups = self.skeleton.skuProduct?.shade_groups;
      self.skeleton.sdSppSkeletonConfig =
        settings?.sd_product_full;
      self.skeleton.sdSppSkeletonVersion =
        self.skeleton.sdSppSkeletonConfig?.dynamic_skeleton?.version;
      self.skeleton.sdSizePickerConfig =
        settings?.elc_ecom?.prodcatConfig?.sizePicker?.productFull?.type;
    },

    renderSkeleton: function () {
      const self = this;
      const sdSppFeatures = ['carousel', 'imageList', 'shadesSidebarButton', 'thumbCarousel', 'shadePickerComponent', 'sizePicker', 'price', 'selectedSize'];
      const prodcatConfig = self.skeleton.productFullProdcatConfig;
      const currentSdSppFeatures = self.searchFeaturesInProdcatConfig(prodcatConfig, sdSppFeatures);

      currentSdSppFeatures.forEach((feature) => {
        self.handleFeature(feature);
      });

      self.applySkeletonLoadedState();
    },

    handleFeature: function (feature) {
      const self = this;
      const featureHandlers = {
        imageList: () => self.renderProductImageList(),
        carousel: () => self.renderProductImageCarousel(),
        shadesSidebarButton: () => self.renderShadeDataInDropdown(),
        thumbCarousel: () => self.renderProductImageCarouselThumbnails(),
        shadePickerComponent: () => self.handleShadePickerComponent(),
        sizePicker: () => self.handleSizePicker(),
        price: () => self.handlePrice(),
        selectedSize: () => self.handleSelectedSize()
      };

      if (featureHandlers[feature]) {
        featureHandlers[feature]();
      }
    },

    handleSizePicker: function () {
      const self = this;
      const sizePickerConfig = self.skeleton.sdSppSkeletonConfig?.dynamic_skeleton?.sizePicker;

      if (self.skeleton.sdSppSkeletonVersion >= 3) {
        if (sizePickerConfig === 'chips') {
          self.selectSizeChip();
        }
        if (self.skeleton.sdSizePickerConfig === 'dropdown') {
          self.renderSizeNameInDropdown();
        }
      }
    },

    handlePrice: function () {
      const self = this;
      const $originalPrice = self.nodes.$sppSkeletonPriceWrapper.find('.js-product-original-price');
      const $productPrice = self.nodes.$sppSkeletonPriceWrapper.find('.js-product-price');
      const $unitPrice = self.nodes.$sppSkeletonPriceWrapper.find('.js-product-price-per-unit');
      const showIncludeTaxLabel = settings?.show_include_tax_label;
      const showUnitPrice = settings?.show_unit_price;
      const prices = self.skeleton.skuProduct?.prices?.[0];
      const priceData = showIncludeTaxLabel ? prices?.include_tax : prices?.exclude_tax;
      const isDiscounted =
        priceData?.original_price !== 0 &&
        priceData?.original_price_formatted !== priceData?.price_formatted;

      if (isDiscounted) {
        $originalPrice.addClass('discounted').text(priceData?.original_price_formatted);
        $productPrice.text(priceData.price_formatted);
      } else {
        $originalPrice.removeClass('discounted').text(priceData?.price_formatted);
      }

      if (showUnitPrice && priceData?.price_per_unit_formatted) {
        $unitPrice.text(priceData?.price_per_unit_formatted);
      }
    },

    handleSelectedSize: function () {
      const self = this;
      const size = self.skeleton.skuProduct?.sizes?.[0]?.value;

      if (self.nodes.$sppSkeletonSelectedSizeWrapper.length) {
        self.nodes.$sppSkeletonSelectedSizeWrapper.text(size);
      }
    },

    handleShadePickerComponent: function () {
      const self = this;

      self.renderDropdownShade();

      if (self.nodes.$sppSkeletonShadeGridWrapper.length) {
        self.selectShadeInGrid();
      }
    },

    searchFeaturesInProdcatConfig: function (data, features) {
      const self = this;
      var matches = [];
      var nestedMatches = [];

      $.each(data, function (key, value) {
        if ($.inArray(key, features) !== -1) {
          matches.push(key);
        }

        if ($.isPlainObject(value) || $.isArray(value)) {
          nestedMatches = self.searchFeaturesInProdcatConfig(value, features);

          if (nestedMatches.length > 0) {
            matches = matches.concat(nestedMatches);
          }
        }
      });

      return matches;
    },

    getQueryParameter: function (param) {
      const params = new URLSearchParams(window.location.search);
      const result = params.get(param);

      return result ? result.replace(/_/gu, ' ') : null;
    },

    getSkuData: function () {
      const self = this;

      if (self.skeleton.shadeName && self.skeleton.sizeNameQueryParameter) {
        return self.getSkuDataBySizeAndShadeName();
      }

      if (self.skeleton.shadeName) {
        return self.getSkuDataByShadeName();
      }

      if (self.skeleton.sizeNameQueryParameter) {
        return self.getSkuDataBySizeName();
      }

      return self.skeleton.defaultSku;
    },

    getSkuDataBySizeAndShadeName: function () {
      const self = this;
      let result = null;

      $.each(self.skeleton.productData, function (_, product) {
        if (product.skus?.length) {
          $.each(product.skus, function (_, sku) {
            if (sku.shade_name === self.skeleton.shadeName && sku.sizes[0]['value'] === self.skeleton.sizeNameQueryParameter) {
              result = sku;

              return false;
            }
          });
        }

        if (result) {
          return false;
        }
      });

      return result;
    },

    getSkuDataByShadeName: function () {
      const self = this;
      let result = null;

      function normalize(str) {
        return str?.replace(/\u00A0/gu, ' ').trim();
      }

      const shadeNameToFind = normalize(self.skeleton.shadeName);

      $.each(self.skeleton.productData, function (_, product) {
        if (product.skus?.length) {
          $.each(product.skus, function (_, sku) {
            const normalizedSkuShade = normalize(sku.shade_name);

            if (normalizedSkuShade === shadeNameToFind) {
              result = sku;

              return false;
            }
          });
        }
        if (result) {
          return false;
        }
      });

      return result;
    },

    getSkuDataBySizeName: function () {
      const self = this;
      let result = null;

      $.each(self.skeleton.productData, function (_, product) {
        if (product.skus?.length) {
          $.each(product.skus, function (_, sku) {
            if (sku.sizes[0]['value'] === self.skeleton.sizeNameQueryParameter) {
              result = sku;

              return false;
            }
          });
        }
        if (result) {
          return false;
        }
      });

      return result;
    },

    getDefaultSku: function () {
      const self = this;
      let result = null;

      $.each(self.skeleton.productData, function (_, product) {
        if (product.skus?.length) {
          $.each(product.skus, function (_, sku) {
            if (sku.is_default_sku) {
              result = sku;

              return false;
            }
          });
        }
        if (result) {
          return false;
        }
      });

      return result;
    },

    renderProductImageCarousel: function () {
      const self = this;
      const src = self.skeleton.skuProduct?.media?.large?.[0]?.src || '';

      if (self.nodes.$sppSkeletonCarouselImg) {
        self.nodes.$sppSkeletonCarouselImg.attr('src', src);
      }
    },

    renderProductImageCarouselThumbnails: function () {
      const self = this;
      const thumbnailsArray = [];
      const imageThumbnails = self.getMediaContentThumbnails().slice(0, 5);

      function isValidImage(img) {
        return (
          img &&
          typeof img === 'object' &&
          typeof img.src === 'string' &&
          img.src.trim() !== ''
        );
      }

      function createThumbnailHTML(img) {
        const {
          src,
          width = '',
          height = '',
          alt = ''
        } = img;

        return `
          <div class="elc-product-images-wrapper js-product-images-wrapper">
            <img class="elc-img preprocess-media"
                src="${src}"
                width="${width}"
                height="${height}"
                alt="${alt}">
          </div>
        `;
      }

      $.each(imageThumbnails, function (_, img) {
        if (isValidImage(img)) {
          thumbnailsArray.push(createThumbnailHTML(img));
        }
      });

      self.nodes.$sppSkeletonImageThumbnails?.html(thumbnailsArray.join(''));
    },

    getMediaContentThumbnails: function () {
      const self = this;
      const skuImages = self.skeleton.skuProduct?.media?.large || [];
      const nonskuImages = self.skeleton.productData?.[0]?.media?.large || [];
      const skuImagesLength = skuImages.length;
      const nonskuImagesLength = nonskuImages.length;
      let images = [];

      if (skuImagesLength > nonskuImagesLength) {
        images = [skuImages[0], ... skuImages];
      } else {
        images = [skuImages[0], ... nonskuImages];
      }

      return images;
    },

    renderDropdownShade: function () {
      const self = this;
      const shadeName = self.skeleton.skuProduct?.shades?.[0]?.name || '';
      const shadeHex = self.skeleton.skuProduct?.shades?.[0]?.hex_val || '#000';
      const shadeDescription = self.skeleton.skuProduct?.shades?.[0]?.description || '';

      self.nodes.$sppSkeletonShadeDropdownName?.html(shadeName);
      self.nodes.$sppSkeletonShadeDropdownDescription?.html(shadeDescription);
      self.nodes.$sppSkeletonShadeDropdownHex?.attr('style', `background-color: ${shadeHex} !important;`);
      self.nodes.$sppSkeletonShadeDropdownLabel?.html(shadeName);
      self.nodes.$sppSkeletonShadeDropdownLabel?.val(shadeName);
    },

    renderShadeDataInDropdown: function () {
      const self = this;
      const shadeName = self.skeleton.skuProduct?.shades?.[0]?.name || '';
      const shadeHex = self.skeleton.skuProduct?.shades?.[0]?.hex_val || '#000';

      self.nodes.$sppSkeletonSideBarButtonWrapper.find('.elc-product-shades-view-button-label').text(shadeName);
      self.nodes.$sppSkeletonSideBarButtonWrapper.find('.elc-product-shades-view-button-icon').attr('style', `background-color: ${shadeHex} !important;`);
    },

    selectShadeInGrid: function () {
      const self = this;
      const $activeShade = self.nodes.$sppSkeletonShadeGridWrapper.find(`[data-sku-id="${self.skeleton.skuId}"]`);

      if ($activeShade.length) {
        $activeShade.addClass('elc-shade-image-selected');
      }
    },

    selectSizeChip: function () {
      const self = this;
      const $activeSize = self.nodes.$sppSkeletonSizeChipsWrapper.find(`[data-sku-id="${self.skeleton.skuId}"]`);

      if ($activeSize.length) {
        $activeSize.addClass('elc-size-picker-box-selected');
      }
    },

    renderProductImageList: function () {
      const self = this;

      if (self.skeleton.sdSppSkeletonVersion >= 3) {
        const imageListArray = [];
        const imageList = self.getMediaContentThumbnails().slice(0, 5);

        $.each(imageList, function (index, img) {
          if (img) {
            imageListArray.push(`
              <img class="elc-img preprocess-media" src="${img.src}" width="${img.width}" height="${img.height}" alt="${img.alt}" loading="${index === 0 ? 'eager' : 'lazy'}">
            `);
          }
        });

        self.nodes.$sppSkeletonProductImageList?.html(imageListArray.join(''));
      }
    },

    renderSizeNameInDropdown: function () {
      const self = this;
      const size = self.skeleton.sizeNameQueryParameter
        ? self.skeleton.sizeNameQueryParameter
        : self.skeleton.skuProduct?.sizes?.[0]?.value;
      const $sizePickerText = self.nodes.$sppSkeletonSizePickerWrapper.find('.elc-size-picker-text');
      const $dropdownReadonlyInput = self.nodes.$sppSkeletonSizePickerWrapper.find('.js-dropdown-readonly-input');

      if ($sizePickerText.length) {
        $sizePickerText.text(size);
      }

      if ($dropdownReadonlyInput.length) {
        $dropdownReadonlyInput.text(size);
      }
    }
  };

  if (settings?.sd_product_full?.dynamic_skeleton?.is_skeleton_hybrid) {
    window.sdSppSkeleton.getDom(document);
    window.sdSppSkeleton.initSkeleton(document);
  }
})(jQuery, Drupal.settings);
